import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'
import urlFor from 'shared/tools/url-helper'

import { changeLayout } from 'client/bookmate/reducers/user-reducer'

import { UserLayoutSwitcher } from 'client/bookmate/blocks/user-layout-switcher'
import { Router } from 'client/shared/types/react-router'
import { CurrentUserState } from 'client/shared/types/current-user'
import { Dispatch, State } from 'shared/types/redux'

type Props = {
  login: string
  content: string
  layout: string
  router: Router
  currentUser: CurrentUserState
  dispatch: Dispatch
}
class _UserLayoutSwitcherBox extends Component<Props> {
  getAvailableUserSections() {
    const sections = ['books', 'audiobooks']
    if (this.props.currentUser.data.comics) {
      sections.push('comicbooks')
    }
    return sections
  }

  onLayoutChange = layout => {
    this.props.dispatch(changeLayout(layout))
  }

  shouldDisableContentSwitcher() {
    const {
      router: {
        params: { filter },
      },
    } = this.props

    return filter === 'uploads'
  }

  onContentChange = content => {
    const {
      dispatch,
      login,
      router: {
        location: { query },
        params: { filter },
      },
    } = this.props

    if (content === 'books') {
      dispatch(push(urlFor.userBooks(login, filter, query)))
    } else if (content === 'audiobooks') {
      dispatch(push(urlFor.userAudioBooks(login, filter, query)))
    } else if (content === 'comicbooks') {
      dispatch(push(urlFor.userComicbooks(login, filter, query)))
    }
  }

  render(): JSX.Element {
    const { layout, content } = this.props

    return (
      <UserLayoutSwitcher
        layout={layout}
        content={content}
        disableContentSwitcher={this.shouldDisableContentSwitcher()}
        availableSections={this.getAvailableUserSections()}
        onLayoutChange={this.onLayoutChange}
        onContentChange={this.onContentChange}
      />
    )
  }
}

const connectWrapper = connect((state: State) => ({
  currentUser: state.currentUser,
  user: state.user,
}))

const wrappers = compose(withRouter, connectWrapper, errorBoundary)

export const UserLayoutSwitcherBox = wrappers(_UserLayoutSwitcherBox)
